import { SVGProps } from 'react';

export const ExclamationTriangleIcon = (props?: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        className={props && props.fill ? '' : 'fill-fletchers-red-500'}
        fill={props && props.fill ? props.fill : ''}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.86605 2.50199C8.48122 1.83495 7.5185 1.83495 7.13367 2.50199L2.23079 11.0003C1.84617 11.667 2.32732 12.5 3.09698 12.5H12.9027C13.6724 12.5 14.1535 11.667 13.7689 11.0003L8.86605 2.50199ZM6.26749 2.00226C7.03715 0.668191 8.96257 0.66819 9.73223 2.00226L14.6351 10.5006C15.4043 11.8339 14.4421 13.5 12.9027 13.5H3.09698C1.55766 13.5 0.595374 11.8339 1.3646 10.5006L6.26749 2.00226ZM7.99986 5.50004C8.276 5.50004 8.49986 5.7239 8.49986 6.00004V8.50004C8.49986 8.77619 8.276 9.00004 7.99986 9.00004C7.72372 9.00004 7.49986 8.77619 7.49986 8.50004V6.00004C7.49986 5.7239 7.72372 5.50004 7.99986 5.50004ZM7.49986 10.5C7.49986 10.2239 7.72372 10 7.99986 10H8.00486C8.281 10 8.50486 10.2239 8.50486 10.5V10.505C8.50486 10.7812 8.281 11.005 8.00486 11.005H7.99986C7.72372 11.005 7.49986 10.7812 7.49986 10.505V10.5Z"
      />
    </svg>
  );
};
